import { times } from 'lodash';
import { mapState } from 'vuex';

export default {
  name: 'WatchlistMixin',

  data() {
    return {
    };
  },

  computed: {
    ...mapState([
      'user_data',
      'userWatchlist',
    ]),

    existsInWatchlist() {
      if (!this.userWatchlist) {
        return false;
      }
      return Object.keys(this.userWatchlist).some(k => k === this.userData.id);
    },

    userCanUseWatchlist() {
      return (this.user_data.userType === 'scout' || this.user_data.userType === 'teams') && this.user_data.id !== this.userData.id;
    },
  },

  methods: {
    updateWatchlist() {
      let message;

      if (this.existsInWatchlist) {
        // with omit removes key from object
        const { [this.userData.id]: omit, ...userWatchlistFiltered } = this.userWatchlist;
        message = 'Profil wurde von Watchlist entfernt';
        this.$store.dispatch('setUserWatchlist', userWatchlistFiltered);
      } else {
        message = ' Profil wurde auf Watchlist gesetzt';
        const watchlist = this.userWatchlist ? this.userWatchlist : {};
        const updatedWatchlist = {
          ...watchlist,
          [this.userData.id]: this.userData,
        };
        this.$store.dispatch('setUserWatchlist', updatedWatchlist);
      }

      this.$store.commit({
        type: 'openSnackbar',
        text: message,
      });
    },
  },
};
